var hashtag_default = {
  "fontElementMap": "i2mvJ",
  "hashtag": "evfV7"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
